<template>
    <div class="thank-you-page">
        <div class="panel">
        <div class="thank-you-message">
            <h2>{{ userData.name }}, thank you for subscribing!</h2>
            <p>We're setting up your account and chatbot. Please wait a moment while we take care of everything for you.
            </p>
        </div>

        <Spinner :show="isLoading" />

        <div v-if="isLoading" class="loading-message">
            <p>Please hold on while we configure everything for you.</p>
        </div>

        <!-- Redirect after setup, if needed -->
        <div v-if="setupComplete">
            <p>Your account and chatbot are ready! Redirecting you to the login page for the dashboard...</p>
        </div>

        <div v-if="successMessage" class="success-message" aria-live="polite">
            {{ successMessage }}
        </div>
        <div v-if="errorMessage" class="error-message" aria-live="assertive">
            {{ errorMessage }}
        </div>
        </div>
    </div>
</template>

<script>
import Spinner from "@/components/SpinnerComponent.vue";
import axios from "axios";

export default {
    name: "ThankYouPage",
    components: {
        Spinner,
    },
    data() {
        return {
            apiUrl: process.env.VUE_APP_MICROSERVICE_API_URL,
            errorMessage: null,
            successMessage: null,
            isLoading: true,
            setupComplete: false,
            userId: null,
            chatbots: [],
            userData: null,
        };
    },
    methods: {
        async initializeAccount() {
            this.errorMessage = "";
            this.successMessage = "";
            this.isLoading = true;
            try {
                // Send the registration data to the backend
                await axios.post(`${this.apiUrl}/users`, {
                    name: this.userData.name + " " + this.userData.surname,
                    email: this.userData.email,
                    password: this.userData.password,
                    company: this.userData.company,
                    company_website: this.userData.website,
                    telephone: this.userData.telephone,
                });

                // console.log(response.data);
                this.successMessage = "Registration successful! Redirecting to login...";
                this.errorMessage = "";
                localStorage.removeItem('userData'); // Remove user data from localStorage

                setTimeout(() => {
                    this.$router.push("/login");
                }, 2000);
            } catch (error) {
                this.errorMessage =
                    error || "An unexpected error occurred.";
                this.successMessage = "";
            } finally {
                this.isLoading = false;
            }
        },
    },
    async beforeMount() {
        const userDataString = localStorage.getItem('userData');

        if (userDataString) {
            this.userData = JSON.parse(userDataString); // Assuming userData is stored as a JSON string
            // console.log("User Data:", this.userData);
            // console.log("URL:", this.apiUrl);
        } else {
            console.error('User data is missing.');
        }
    },
    async mounted() {
        await this.initializeAccount();
    },
};
</script>

<style scoped>
.thank-you-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--bg-mid);
    padding: 30px;
}

.panel {
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);
    max-width: 600px;
    width: 100%;
    padding: 20px;
    background-color: var(--bg-glass);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.thank-you-message {
    text-align: center;
    margin-bottom: 20px;
}

h2 {
    font-size: 1.5rem;
    color: #27374d;
    margin-bottom: 0.5rem;
}

p {
    color: #5c6b73;
    font-size: 1.1rem;
}

.loading-message {
    margin-top: 20px;
    color: #fc5f3a;
    font-size: 1.2rem;
}
</style>